import React, { useEffect } from "react";
import cs from "classnames";
import classes from "views/ListView/listView.module.scss";
import { citiesMap } from "config/cityData";

const ListView = ({ cities, setCity }) => {
  useEffect(() => {
    if(document.documentElement.classList.contains('overflow-hidden')) {
      document.documentElement.classList.remove('overflow-hidden');
    }
  }, [])
  return (
    <div className={classes.root}>
      <h2 className="text-white">Select a City:</h2>
      <div className="row align-items-center justify-content-center">
        {cities.map((city, index) => (
          <div
            key={index}
            className={cs("col-10 col-sm-6 col-md-4 col-lg-3", classes.cityWrapper)}
            onClick={() => setCity(city)}
          >
            <div
              className={cs(
                "d-flex justify-content-center align-items-center",
                classes.cityBtn
              )}
            >
              <h4 className="m-0">{citiesMap[city] || city}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListView;
